import { ReactNode } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

type AnimatedElementProps = {
  children: ReactNode;
  isVisible: Boolean;
  delay?: number;
  name: string;
};

const AnimatedElement = ({
  isVisible,
  children,
  name,
  delay = 0,
}: AnimatedElementProps) => (
  <AnimatePresence>
    {isVisible && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        key={name}
        transition={{
          opacity: { duration: 0.4, ease: 'easeInOut' },
          delayChildren: delay,
        }}
        style={{
          transformOrigin: 'top',
          overflow: 'hidden',
        }}
      >
        {children}
      </motion.div>
    )}
  </AnimatePresence>
);

export default AnimatedElement;
